// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const mapWrapper = "About__mapWrapper__Wg7f1";
export const medium = "500";
export const paragraph = "About__paragraph__Ek0dl font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const regular = "400";
export const sans = "'sans'";
export const section = "About__section__OpGby";
export const semibold = "600";
export const serif = "'serif'";
export const subtitle = "About__subtitle__QmADW font-faces__atlasGroteskMedium__1ilbx font-faces__atlasGrotesk__rYPJr";